<template src='./categorieModal.pug' lang='pug'></template>

<script>
import { Money } from 'v-money'
import Datepicker from 'vuejs-datepicker'
import BetterModal from '../../modals/betterModal/BetterModal'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import looseDeepEqual from '../../../utils/looseDeepEqual.js'
import idioma from '../../../../build/language/index'
import customValidator from '../../../utils/customValidator'
import { convertToUTC } from '../../../utils/dateUtils'

export default {
  name: 'CategorieModal',

  components: {
    BetterModal,
    ButtonPrimary,
    Money,
    Datepicker
  },

  props: {
    idEditingCategory: {
      type: String,
      default: null
    },
    subCategoryParent: {
      type: Object,
      default: null
    },
    categories: {
      type: Array,
      default: () => []
    },
    lastCategoryOrder: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      requestSent: false,
      category: {
        description: null,
        accountingId: null,
        type: '',
        emUso: false,
        initialBalance: '',
        initialBalanceDate: null
      },
      parentCategory: null,
      creatingNumber: 0,
      titles: {
        main: '',
        sub: ''
      },
      idioma: idioma,
      moneyMask: {},
      inputDate: null,
      disabledDates: {
        to: new Date('January 01, 2010')
      }
    }
  },

  computed: {
    datePickerLanguage () {
      return this.idioma.getDatePickerLanguageObject()
    },
    moneyMaskLength () {
      return this.idioma.getDatePickerLanguage() === 'pt-br' ? 21 : 20
    }
  },

  watch: {
    category: {
      handler () {
        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, this.category))
        if (this.category.type !== '' && this.category.type !== 'W') {
          this.category.initialBalance = ''
          this.category.initialBalanceDate = null
        }
      },
      deep: true
    }
  },

  methods: {
    createOrder () {
      if (!this.parentCategory) {
        if (this.categories.length > 0) {
          const lastCategory = this.categories[this.categories.length - 1]
          if ('number' in lastCategory) {
            return parseInt(lastCategory.number) + 1
          }
        }
        return 1
      }
      if (this.parentCategory.children && this.parentCategory.children.length > 0) {
        const lastChildCategory = this.parentCategory.children[this.parentCategory.children.length - 1]
        if ('number' in lastChildCategory) {
          return this.parentCategory.number + '.' + (parseInt(lastChildCategory.number.split('.').pop()) + 1)
        }
      }
      return this.parentCategory.number + '.' + 1
    },

    defineTitles () {
      if (this.idEditingCategory) {
        if (this.parentCategory) {
          this.titles.main = this.$t('categoria.modal.titulo.edicaoSubCategoria')
          this.titles.sub = this.$t('categoria.modal.subtitulo.edicaoSubCategoria')
        } else {
          this.titles.main = this.$t('categoria.modal.titulo.edicaoCategoria')
          this.titles.sub = this.$t('categoria.modal.subtitulo.edicaoCategoria')
        }
      } else {
        if (this.parentCategory) {
          this.titles.main = this.$t('categoria.modal.titulo.novaSubCategoria')
          this.titles.sub = this.$t('categoria.modal.subtitulo.novaSubCategoria')
        } else {
          this.titles.main = this.$t('categoria.modal.titulo.novaCategoria')
          this.titles.sub = this.$t('categoria.modal.subtitulo.novaCategoria')
        }
      }
    },

    validate () {
      this.$validator.validateAll()
        .then((result) => {
          if (result && this.isWalletFieldsValid()) {
            this.save()
          } else {
            this.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', this.getTitleError())
          }
        })
    },

    isWalletFieldsValid () {
      let isValid = this.category.type !== 'W' || (this.category.type === 'W' && (this.$refs.money.$el.value !== '' && this.category.initialBalanceDate !== null))

      if (!isValid) {
        if (this.$refs.money.$el.value === '') {
          this.errors.add('initialBalance', 'balance')
          this.errors.remove('initialBalanceDate')
        } else {
          this.errors.add('initialBalanceDate', 'balance')
          this.errors.remove('initialBalance')
        }
      } else {
        this.errors.remove('initialBalance')
        this.errors.remove('initialBalanceDate')
      }
      return isValid
    },

    getTitleError () {
      if (this.parentCategory) {
        return 'categoria.subCategoria.erro.salvar'
      }
      return 'categoria.erro.salvar'
    },

    save () {
      this.requestSent = true
      this.$store.dispatch('saveCategorie', this.createSavingObject())
        .then((response) => {
          this.$root.$refs.notification.success(response.data.message)
          this.$emit('close-modal')
        })
        .catch(error => {
          this.$root.$refs.notification.error(error.message)
        })
        .finally(() => {
          this.requestSent = false
        })
    },

    createSavingObject () {
      return {
        id: this.category.id,
        categoriaPai: {
          id: this.parentCategory ? this.parentCategory.id : null
        },
        nome: this.category.description,
        numero: this.creatingNumber,
        tipo: this.category.type !== 'null' ? this.category.type : null,
        idContabil: this.category.accountingId,
        ordem: this.lastCategoryOrder + 1,
        saldoInicial: typeof this.category.initialBalance === 'string' && this.category.initialBalance === '' ? null : this.removeBankAccountMask(),
        dataSaldoInicial: convertToUTC(this.category.initialBalanceDate)
      }
    },

    removeBankAccountMask () {
      let splittedInitialBalance = this.category.initialBalance.toString().split(' ')

      if (this.category.initialBalance && splittedInitialBalance.length > 1) {
        return splittedInitialBalance[1].replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1')
      }
      return this.category.initialBalance.replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1')
    },

    validateDate () {
      let isValid = this.inputDate.value.length === 10 && customValidator.isValidDate(this.inputDate.value)
      if (!isValid) {
        this.category.initialBalanceDate = null
      } else {
        this.errors.remove('initialBalanceDate')
      }
    }

  },

  async created () {
    if (this.subCategoryParent) {
      this.parentCategory = { ...this.subCategoryParent }
    }
    if (!this.idEditingCategory) {
      this.defineTitles()
      this.creatingNumber = this.createOrder()
      this.defaultObject = { ...this.category }
      return
    }

    try {
      const response = await this.$store.dispatch('getCategorie', this.idEditingCategory)
      this.category = response.data
      if (this.category && this.category.fatherCategory) {
        this.parentCategory = { ...this.category.fatherCategory }
      } else {
        this.parentCategory = null
      }
      this.creatingNumber = this.category.number
      this.category.initialBalance = this.category.type === 'W' ? this.category.initialBalance.toFixed(2) : ''
      this.category.initialBalanceDate = this.category.type === 'W' ? this.category.initialBalanceDate : null
      this.defaultObject = { ...this.category }
      this.defineTitles()
    } catch (err) {
      this.$root.$refs.notification.error(err.data)
    }
  },

  mounted () {
    this.moneyMask = this.idioma.getMoneyMaskByLanguage()
    setTimeout(() => {
      this.inputDate = document.getElementById('initialBalanceDate')
      if (this.inputDate) {
        this.inputDate.setAttribute('autocomplete', 'off')
        this.inputDate.addEventListener('blur', () => {
          this.validateDate()
        })
      }
    }, 100)
  },

  beforeDestroy () {
    this.$store.dispatch('setHasUnsavedChanges', false)
  }
}
</script>

<style>
.radio-wallet {
  margin-top: 0;
}

.datepicker-wrapper-wallet > .vdp-datepicker__calendar {
  bottom: 100% !important;
}
</style>



// WEBPACK FOOTER //
// CategorieModal.vue?c8ff2038